export default __webpack_public_path__ + "static/media/ic-clock-out.6241c537.svg";